export const blockIconsEditorQueryStats = (
	<span className='material-symbols-outlined'>query_stats</span>
);
